import React, { memo } from "react";

import { OFFICE_STATUS_OPTIONS } from "services/api/offices/consts";
import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";
import CheckIcon from "ui/modules/fleet/vehicles/pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleEditCard/components/VehicleWizardIntro/scenes/CheckIcon";

import { OFFICE_INTRO_SAMPLE } from "../consts";
import { OfficeSceneProps } from "../types";

/** Korak "Pregled": popis dovršenih dijelova i status poslovnice. */
const OfficeSummaryScene: React.FC<OfficeSceneProps> = ({ formValues, name }) => {
  const status = OFFICE_STATUS_OPTIONS.find((option) => option.value === formValues.status)?.text ?? "Aktivna";

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Pregled</div>
          <div className="text-sm font-bold text-slate-800 truncate">{name}</div>
          <div className="mt-3 space-y-1">
            {OFFICE_INTRO_SAMPLE.summary.map((item) => (
              <div key={item} className="flex items-center gap-2 rounded-md bg-slate-50 px-3 py-1 text-[0.7rem]">
                <CheckIcon />
                <span className="font-medium text-slate-700">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Status</div>
          <div className="mt-2 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-emerald-500 motion-safe:animate-pulse" />
            <span className="text-xs font-bold text-slate-800">{status}</span>
          </div>
          <div className="mt-1 text-[0.65rem] text-slate-400 truncate">
            {formValues.code || OFFICE_INTRO_SAMPLE.code}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Spremna za rad"
          subtitle="Sve se kasnije može dopuniti"
          iconClassName="bg-emerald-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#047857" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M20 6L9 17l-5-5" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(OfficeSummaryScene);
